
import getActions from '../../sagas/map';

export default function buttonCommandClick(dispatch, id, params) {
    const addCommand = getActions(dispatch).addCommand;
    addCommand(id, params);
}
